import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';

import FooterTop from '../../components/commons/footer/FooterTop'
import FooterMiddle from '../../components/commons/footer/FooterMiddle'
import FooterBottom from '../../components/commons/footer/FooterBottom'

class Footer extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div className="footer">
        <FooterTop />
        <FooterMiddle />
        <FooterBottom />
      </div>
    )
  }

}

export default connect((state) => {
  return {
    loading: state.getIn(['users', 'loading']),
    error: state.getIn(['users', 'error'])
  };
})(Footer);



// WEBPACK FOOTER //
// ./src/containers/commons/Footer.js